import {CLEAN_ERROR} from "../actions/error";

const defaultState = {
  hasError: false,
  error: {
    message: '',
    type: null
  }
};


export const errorReducer = (state = defaultState, action) => {
  const {type, meta, payload, error} = action;

  if (error && meta.isInterpretedError) {
    return {
      hasError: true,
      error: payload
    }
  }

  if (type === CLEAN_ERROR) {
    return {
      hasError: false,
      error: {}
    }
  } else {
    return state;
  }
}


// WEBPACK FOOTER //
// ./src/errors/ErrorReducer.js